import { Box, styled } from "@mui/material";

export const CurrencyWrapper = styled(Box)(() => {
    return {
        "& form": {
            display: "flex",
            alignItems: "flex-end",
            cursor: "pointer",
            "& .search-icon-box": {
                padding: "calc(var(--basic-padding)/4)",
                background: "#D7D7D7",
                display: "flex",
            },
            "& .MuiInputBase-adornedStart": {
                padding: 0,
            },
            "& .MuiInputBase-inputAdornedStart": {
                minWidth: "18.75rem",
                padding: "calc(var(--basic-padding)/4)",
            },
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        "& thead tr": {
            backgroundColor: "#842581",
            "& th": {
                color: "#FFFFFF",
                width: "7rem",
                border: "1px solid #D9D9D9",
            }
        },
        "tbody tr": {
            "& td:last-child": {
                width: "10%",
            },
            "& td": {
                border: "1px solid #D9D9D9",
            }
        },
        "@media screen and (min-width: 1024px)": {
            "& form": {
                justifyContent: "flex-end"
            }
        }
    }
})